import React, { useEffect, useState } from 'react'

//Dependencies.
import { Link, useLocation } from 'react-router-dom';
import { Button, NavbarBrand } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../../databases/firebase';
import { updateReduxWithFSUsersData } from '../../../slices/allUsersSlice';
import { useNavigate } from 'react-router-dom';
import { updateReduxWithFSvideosData } from '../../../slices/allVideosSlice';
import { updateReduxWithFSactiveChallengesData, updateReduxWithFScompletedChallengesData, updateReduxWithFSupcomingChallengesData } from '../../../slices/challengesSlice';
import { updateFSupcomingChallenges } from '../../../slices/challengesSlice';
import { store } from '../../../app/store';

//Components.
import SignUpModal from '../../Modal/sign-up/SignUpModal';
import LoginModal from '../../Modal/login/LoginModal';

//Functions.
 //Callbacks/dispatch.
 import { loggedInUser, logUserOutFromFBandRedux } from '../../../slices/allUsersSlice';
 //Miscellaneous Functions.
 import { getAllDocumentIDFromFirestore, updateAllDocumentsInFS } from '../../../functions/firebase/firestore';
 
import './MainNavbar.styles.css';


const MainNavbar = () => {
   const location = useLocation();
   const currentUser = useSelector(loggedInUser);

   const dispatch = useDispatch();

   const navigate = useNavigate();

   const currentUserInFSemail = auth?.currentUser?.email;

   const [modal, setModal] = useState(false);
   const [loginModal, setLoginModal] = useState(false);

   const mainNavbarName = location.pathname === "/" ? "m-0 p-0 main-navbar-1" : "m-0 p-0 main-navbar-2";

   useEffect(() => {
      getAllDocumentIDFromFirestore(["internet-idol-faceoff", "Videos", "allVideos"])
      return () => {

      };
   }, []);

   useEffect(() => {
      onAuthStateChanged(auth, async function (user) {
         await dispatch(updateReduxWithFSUsersData());
         await dispatch(updateReduxWithFSactiveChallengesData());
         await dispatch(updateReduxWithFSupcomingChallengesData());
         await dispatch(updateReduxWithFScompletedChallengesData());
         await dispatch(updateReduxWithFSvideosData());

         if (user) {
            navigate(`/member/_userID/${user.uid}/home`);
         }
      });
      return () => {
         
      };
   }, [currentUserInFSemail]);

   const resetAllVideos = () => updateAllDocumentsInFS({ record: { losses: 0, ties: 0, winPct: 0, wins: 0 } }, ["internet-idol-faceoff", "Videos", "allVideos"])

   return (
      <div className='main-navbar-wrapper sticky-top p-0 m-0'>
         {
            modal && <SignUpModal modal={modal} setModal={setModal} />
         }
         {
            loginModal && <LoginModal modal={loginModal} setModal={setLoginModal} />
         }
         <NavbarBrand className='navbarBrand px-5 pt-3'>
            <h1 className='text-danger'>Internet Idol Challenge</h1>
         </NavbarBrand>
         <nav className={`${mainNavbarName} m-0 p-0`}>
            {
               currentUser._userID
               &&
               <Link to={`/member/_userID/${currentUser._userID}/home`}><strong>{currentUser.username.toUpperCase()}'s HOME PAGE</strong></Link>
            }
            <Link to='/' style={{textDecoration: 'none'}}><strong>HOME PAGE</strong></Link>
            <Link to='/instructions' style={{ textDecoration: 'none', backgroundColor: 'lightgreen' }}><strong className='text-danger p-1'>NEW USER? START HERE!!!</strong></Link>
            {
               currentUser.username === "admin" && <Button color='danger' onClick={resetAllVideos}>RESET ALL VIDEO RECORDS!!!</Button>
            }
            {
               currentUser._userID ?
                  <div className='registration-wrapper'>
                     <strong className='mx-3' onClick={() => dispatch(logUserOutFromFBandRedux())}>SIGN OUT</strong>
                  </div>
                  :
                  <div className='registration-wrapper'>
                     <strong
                        onClick={() => setModal(!modal)}
                        className='mx-3 sign-up'
                     >
                        SIGN-UP
                     </strong>
                     <strong
                        onClick={() => setLoginModal(!loginModal)}
                        className='mx-3 login'
                     >
                        LOGIN
                     </strong>
                  </div>                  
            }                        
         </nav>
      </div>
     
   )
}

export default MainNavbar